// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 获取活动列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.GetActivityListResp
export const getActivityList = (data) => {
  return service({
    url: '/v1/activity/activityList',
    method: 'post',
    data
  })
}
// 获取活动详情
// Req : open_proto.client.v1.activity.GetActivityDetailReq
// Resp: open_proto.client.v1.activity.ActivityDetail
export const getActivityDetail = (data) => {
  return service({
    url: '/v1/activity/activityDetail',
    method: 'post',
    data
  })
}
// 领取活动奖励
// Req : open_proto.client.v1.activity.GetActivityDetailReq
// Resp: open_proto.client.v1.activity.ReceiveActivityRewardResp
export const receiveActivityReward = (data) => {
  return service({
    url: '/v1/activity/receiveActivityReward',
    method: 'post',
    data
  })
}
// 领取返利活动奖励
// Req : open_proto.client.v1.activity.ReceiveRebateActivityRewardReq
// Resp: open_proto.client.v1.activity.ReceiveRebateActivityRewardResp
export const receiveRebateActivityReward = (data) => {
  return service({
    url: '/v1/activity/receiveRebateActivityReward',
    method: 'post',
    data
  })
}
// 返利已配置周期
// Req : open_proto.client.v1.activity.RebateEnableSettlePeriodReq
// Resp: open_proto.client.v1.activity.RebateEnableSettlePeriodResp
export const rebateEnableSettlePeriod = (data) => {
  return service({
    url: '/v1/activity/rebateEnableSettlePeriod',
    method: 'post',
    data
  })
}
// 预览活动奖励
// Req : open_proto.client.v1.activity.PreviewActivityRewardReq
// Resp: open_proto.client.v1.activity.PreviewActivityRewardResp
export const previewActivityReward = (data) => {
  return service({
    url: '/v1/activity/previewActivityReward',
    method: 'post',
    data
  })
}
// 预览活动奖励
// Req : open_proto.client.v1.activity.PreviewDownloadActivityRewardReq
// Resp: open_proto.client.v1.activity.PreviewActivityRewardResp
export const previewDownloadActivityReward = (data) => {
  return service({
    url: '/v1/activity/previewDownloadActivityReward',
    method: 'post',
    data
  })
}
// 红包兑换码领取
// Req : open_proto.client.v1.activity.RedRedeemCodeReceiveReq
// Resp: open_proto.client.v1.activity.RedRedeemCodeReceiveResp
export const redRedeemCodeReceive = (data) => {
  return service({
    url: '/v1/activity/redRedeemCodeReceive',
    method: 'post',
    data
  })
}
// 定时红包领取
// Req : open_proto.client.v1.activity.RedEnvelopeTimingReq
// Resp: open_proto.client.v1.activity.RedRedeemCodeReceiveResp
export const redEnvelopeTimingReceive = (data) => {
  return service({
    url: '/v1/activity/redEnvelopeTimingReceive',
    method: 'post',
    data
  })
}
// 定时红包信息获取
// Req : open_proto.client.v1.activity.RedEnvelopeTimingReq
// Resp: open_proto.client.v1.activity.RedEnvelopeTimingGetResp
export const redEnvelopeTimingGet = (data) => {
  return service({
    url: '/v1/activity/redEnvelopeTimingGet',
    method: 'post',
    data
  })
}
// 定时红包膨胀奖金预览
// Req : open_proto.client.v1.activity.RedEnvelopeTimingRewardPreviewReq
// Resp: open_proto.client.v1.activity.RedEnvelopeTimingRewardPreviewResp
export const redEnvelopeTimingRewardPreview = (data) => {
  return service({
    url: '/v1/activity/redEnvelopeTimingRewardPreview',
    method: 'post',
    data
  })
}
// 获取当前转盘抽奖次数
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.TurntableDrawTimesResp
export const getTurntableDrawTimes = (data) => {
  return service({
    url: '/v1/activity/getTurntableDrawTimes',
    method: 'post',
    data
  })
}
// 转盘抽奖
// Req : open_proto.client.v1.activity.TurntableDrawReq
// Resp: open_proto.client.v1.activity.TurntableDrawResp
export const turntableDraw = (data) => {
  return service({
    url: '/v1/activity/turntableDraw',
    method: 'post',
    data
  })
}
// 获取邀请码信息
// Req : open_proto.client.v1.activity.GetInviteCodeInfoReq
// Resp: open_proto.client.v1.activity.GetInviteCodeInfoResp
export const getInviteCodeInfo = (data) => {
  return service({
    url: '/v1/activity/getInviteCodeInfo',
    method: 'post',
    data
  })
}
// 获取用户宝箱信息
// Req : open_proto.client.v1.activity.GetUserPreciousReq
// Resp: open_proto.client.v1.activity.GetUserPreciousResp
export const getUserPrecious = (data) => {
  return service({
    url: '/v1/activity/getUserPrecious',
    method: 'post',
    data
  })
}
// 预览充值活动
// Req : open_proto.client.v1.activity.PreviewRechargeActivityReq
// Resp: open_proto.client.v1.activity.PreviewRechargeActivityResp
export const previewRechargeActivity = (data) => {
  return service({
    url: '/v1/activity/previewRechargeActivity',
    method: 'post',
    data
  })
}
// 获取活动配置-已转用户汇率
// Req : open_proto.client.v1.activity.GetActivityConfigReq
// Resp: open_proto.client.v1.activity.GetActivityConfigResp
export const getActivityConfig = (data) => {
  return service({
    url: '/v1/activity/getActivityConfig',
    method: 'post',
    data
  })
}
// 获取累计宝箱列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.GetGrandPreciousListResp
export const getGrandPreciousList = (data) => {
  return service({
    url: '/v1/activity/getGrandPreciousList',
    method: 'post',
    data
  })
}
// 领取累计宝箱
// Req : open_proto.client.v1.activity.ReceiveGrandPreciousReq
// Resp: open_proto.client.v1.activity.ReceiveGrandPreciousResp
export const receiveGrandPrecious = (data) => {
  return service({
    url: '/v1/activity/receiveGrandPrecious',
    method: 'post',
    data
  })
}
// 领取所有可以领取的累计宝箱
// Req : open_proto.client.v1.activity.ReceiveGrandPreciousAllReq
// Resp: open_proto.client.v1.activity.ReceiveGrandPreciousAllResp
export const receiveGrandPreciousAll = (data) => {
  return service({
    url: '/v1/activity/receiveGrandPreciousAll',
    method: 'post',
    data
  })
}
// 获取领取所有可以领取的累计宝箱状态
// Req : open_proto.client.v1.activity.GetReceiveGrandPreciousAllStatusReq
// Resp: open_proto.client.v1.activity.ReceiveGrandPreciousAllResp
export const getReceiveGrandPreciousAllStatus = (data) => {
  return service({
    url: '/v1/activity/getReceiveGrandPreciousAllStatus',
    method: 'post',
    data
  })
}
// 返利详情
// Req : open_proto.client.v1.activity.RebateDetailReq
// Resp: open_proto.client.v1.activity.RebateDetailResp
export const rebateDetail = (data) => {
  return service({
    url: '/v1/activity/rebateDetail',
    method: 'post',
    data
  })
}
// 转盘奖励列表
// Req : open_proto.client.v1.activity.TurntableRewardListReq
// Resp: open_proto.client.v1.activity.TurntableRewardListResp
export const turntableRewardList = (data) => {
  return service({
    url: '/v1/activity/turntableRewardList',
    method: 'post',
    data
  })
}
// 获取转盘历史总发放
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.TurntableSumRewardResp
export const turntableSumReward = (data) => {
  return service({
    url: '/v1/activity/turntableSumReward',
    method: 'post',
    data
  })
}
// 获取拉新助力信息
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.NewUserHelpInfoResp
export const getNewUserHelpInfo = (data) => {
  return service({
    url: '/v1/activity/getNewUserHelpInfo',
    method: 'post',
    data
  })
}
// 拉新助力抽奖
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.NewUserHelpDrawResp
export const newUserHelpDraw = (data) => {
  return service({
    url: '/v1/activity/newUserHelpDraw',
    method: 'post',
    data
  })
}
// 拉新助力领取现金
// Req : open_proto.client.v1.activity.NewUserHelpReceiveReq
// Resp: open_proto.client.v1.activity.NewUserHelpReceiveResp
export const newUserHelpReceive = (data) => {
  return service({
    url: '/v1/activity/newUserHelpReceive',
    method: 'post',
    data
  })
}
// 拉新助力奖励记录
// Req : open_proto.client.v1.activity.GetNewUserHelpRewardListReq
// Resp: open_proto.client.v1.activity.GetNewUserHelpRewardListResp
export const getNewUserHelpRewardList = (data) => {
  return service({
    url: '/v1/activity/getNewUserHelpRewardList',
    method: 'post',
    data
  })
}
// 参与拉新助力活动
// Req : open_proto.client.v1.activity.JoinNewUserHelpReq
// Resp: open_proto.client.v1.activity.JoinNewUserHelpResp
export const joinNewUserHelp = (data) => {
  return service({
    url: '/v1/activity/joinNewUserHelp',
    method: 'post',
    data
  })
}
// 打码排行榜记录
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.BetRankResp
export const betRankCurrent = (data) => {
  return service({
    url: '/v1/activity/betRank',
    method: 'post',
    data
  })
}
// 打码排行榜记录历史
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.BetRankHistoryResp
export const betRankHistory = (data) => {
  return service({
    url: '/v1/activity/betRankHistory',
    method: 'post',
    data
  })
}
// 打码排行榜记录未认证
// Req : open_proto.client.v1.activity.BetRankNoAuthReq
// Resp: open_proto.client.v1.activity.BetRankResp
export const betRankCurrentNoAuth = (data) => {
  return service({
    url: '/v1/activity/betRankNoAuth',
    method: 'post',
    data
  })
}
// 打码排行榜记录历史未认证
// Req : open_proto.client.v1.activity.BetRankNoAuthReq
// Resp: open_proto.client.v1.activity.BetRankHistoryResp
export const betRankHistoryNoAuth = (data) => {
  return service({
    url: '/v1/activity/betRankHistoryNoAuth',
    method: 'post',
    data
  })
}
// 宝箱下级列表
// Req : open_proto.client.v1.activity.PreciousChildListReq
// Resp: open_proto.client.v1.activity.PreciousChildListResp
export const preciousChildList = (data) => {
  return service({
    url: '/v1/activity/preciousChildList',
    method: 'post',
    data
  })
}
// 获取签到详情
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.GetSignDetailResp
export const getSignDetail = (data) => {
  return service({
    url: '/v1/activity/getSignDetail',
    method: 'post',
    data
  })
}
// 签到
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.SignInResp
export const signIn = (data) => {
  return service({
    url: '/v1/activity/signIn',
    method: 'post',
    data
  })
}
// 领取签到累计奖励
// Req : open_proto.client.v1.activity.ReceveSignTotalRewardReq
// Resp: open_proto.client.v1.activity.ReceveSignTotalRewardResp
export const receveSignTotalReward = (data) => {
  return service({
    url: '/v1/activity/receveSignTotalReward',
    method: 'post',
    data
  })
}
// 获取利息宝活动详情
// Req : open_proto.client.v1.activity.GetInterestTreasureActivityReq
// Resp: open_proto.client.v1.activity.GetInterestTreasureActivityResp
export const getInterestTreasureActivity = (data) => {
  return service({
    url: '/v1/activity/interestTreasureActivity',
    method: 'post',
    data
  })
}
// 获取利息宝钱包信息
// Req : open_proto.client.v1.activity.UserInterestTreasureWalletInfoReq
// Resp: open_proto.client.v1.activity.UserInterestTreasureWallet
export const userInterestTreasureWalletInfo = (data) => {
  return service({
    url: '/v1/activity/userInterestTreasureWallet/info',
    method: 'post',
    data
  })
}
// 利息宝金额转入
// Req : open_proto.client.v1.activity.UserInterestTreasureWalletRechargeReq
// Resp: open_proto.common.SuccessResp
export const userInterestTreasureWalletRecharge = (data) => {
  return service({
    url: '/v1/activity/userInterestTreasureWallet/recharge',
    method: 'post',
    data
  })
}
// 利息宝金额转出
// Req : open_proto.client.v1.activity.UserInterestTreasureWalletWithdrawReq
// Resp: open_proto.common.SuccessResp
export const userInterestTreasureWalletWithdraw = (data) => {
  return service({
    url: '/v1/activity/userInterestTreasureWallet/withdraw',
    method: 'post',
    data
  })
}
// 利息宝领取利息
// Req : open_proto.client.v1.activity.UserInterestTreasureWalletInterestAmountReq
// Resp: open_proto.common.SuccessResp
export const userInterestTreasureWalletInterestAmount = (data) => {
  return service({
    url: '/v1/activity/userInterestTreasureWallet/interestAmount',
    method: 'post',
    data
  })
}
// 利息宝领取利息
// Req : open_proto.client.v1.activity.UserInterestTreasureWalletRecordListReq
// Resp: open_proto.client.v1.activity.UserInterestTreasureWalletRecordListResp
export const userInterestTreasureWalletRecordList = (data) => {
  return service({
    url: '/v1/activity/userInterestTreasureWalletRecord/list',
    method: 'post',
    data
  })
}
// 宝箱充值汇总
// Req : open_proto.client.v1.activity.PreciousRechargeDetailReq
// Resp: open_proto.client.v1.activity.PreciousRechargeDetailResp
export const preciousRechargeDetail = (data) => {
  return service({
    url: '/v1/activity/preciousRechargeDetail',
    method: 'post',
    data
  })
}
// 获取红点展示信息
// Req : open_proto.client.v1.activity.GetRedDotReq
// Resp: open_proto.client.v1.activity.GetRedDotResp
export const getRedDot = (data) => {
  return service({
    url: '/v1/activity/redDot',
    method: 'post',
    data
  })
}
// 获取可领取活动
// Req : open_proto.client.v1.activity.GetCanReceiveActivityReq
// Resp: open_proto.client.v1.activity.GetCanReceiveActivityResp
export const getCanReceiveActivity = (data) => {
  return service({
    url: '/v1/activity/getCanReceiveActivity',
    method: 'post',
    data
  })
}
// 集卡
// Req : open_proto.client.v1.activity.CollectCardDrawReq
// Resp: open_proto.client.v1.activity.CollectCardDrawResp
export const collectCardDraw = (data) => {
  return service({
    url: '/v1/activity/collectCardDraw',
    method: 'post',
    data
  })
}
// 获取用户冲榜状态
// Req : open_proto.client.v1.activity.GetUserMultiRushRankReq
// Resp: open_proto.client.v1.activity.GetUserMultiRushRankResp
export const getUserMultiRushRank = (data) => {
  return service({
    url: '/v1/activity/getUserMultiRushRank',
    method: 'post',
    data
  })
}
// 集卡
// Req : open_proto.client.v1.activity.CollectCardExchangeReq
// Resp: open_proto.client.v1.activity.CollectCardExchangeResp
export const collectCardExchange = (data) => {
  return service({
    url: '/v1/activity/collectCardExchange',
    method: 'post',
    data
  })
}
// 领取奖励
// Req : open_proto.client.v1.activity.ReceiveMultiRushRankRewardReq
// Resp: open_proto.client.v1.activity.ReceiveMultiRushRankRewardResp
export const receiveMultiRushRankReward = (data) => {
  return service({
    url: '/v1/activity/receiveMultiRushRankReward',
    method: 'post',
    data
  })
}
// 获取集卡信息
// Req : open_proto.client.v1.activity.GetCollectCardStatisticReq
// Resp: open_proto.client.v1.activity.GetCollectCardStatisticResp
export const getCollectCardStatistic = (data) => {
  return service({
    url: '/v1/activity/getCollectCardStatistic',
    method: 'post',
    data
  })
}
// 冲榜信息
// Req : open_proto.client.v1.activity.GetMultiRushRankStatusReq
// Resp: open_proto.client.v1.activity.GetMultiRushRankStatusResp
export const getMultiRushRankStatus = (data) => {
  return service({
    url: '/v1/activity/getMultiRushRankStatus',
    method: 'post',
    data
  })
}
// 领取记录
// Req : open_proto.client.v1.activity.GetMultiRushRankRecordReq
// Resp: open_proto.client.v1.activity.GetMultiRushRankRecordResp
export const getMultiRushRankRecord = (data) => {
  return service({
    url: '/v1/activity/getMultiRushRankRecord',
    method: 'post',
    data
  })
}
// 获取活动奖励引导数据
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.ActivityRewardGuide
export const getActivityRewardGuide = (data) => {
  return service({
    url: '/v1/activity/getActivityRewardGuide',
    method: 'post',
    data
  })
}
// 领取引导数据的活动奖励
// Req : open_proto.client.v1.activity.ReceiveActivityRewardGuideReq
// Resp: open_proto.client.v1.activity.ReceiveActivityRewardGuideResp
export const receiveActivityRewardGuide = (data) => {
  return service({
    url: '/v1/activity/receiveActivityRewardGuide',
    method: 'post',
    data
  })
}
// 神秘奖励领取
// Req : open_proto.client.v1.activity.MysteriousRewardsReceiveReq
// Resp: open_proto.client.v1.activity.MysteriousRewardsReceiveResp
export const mysteriousRewardsReceive = (data) => {
  return service({
    url: '/v1/activity/mysteriousRewardsReceive',
    method: 'post',
    data
  })
}
// 神秘奖励领取
// Req : open_proto.client.v1.activity.MysteriousRewardsPreviewReq
// Resp: open_proto.client.v1.activity.MysteriousRewardsPreviewResp
export const mysteriousRewardsPreview = (data) => {
  return service({
    url: '/v1/activity/mysteriousRewardsPreview',
    method: 'post',
    data
  })
}
// 团队打码排行榜记录
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.TeamBetRankResp
export const teamBetRankCurrent = (data) => {
  return service({
    url: '/v1/activity/teamBetRank',
    method: 'post',
    data
  })
}
// 神秘奖励列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.MysteriousRewardsListResp
export const mysteriousRewardsList = (data) => {
  return service({
    url: '/v1/activity/mysteriousRewardsList',
    method: 'post',
    data
  })
}
// 团队打码排行榜记录历史
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.TeamBetRankHistoryResp
export const teamBetRankHistory = (data) => {
  return service({
    url: '/v1/activity/teamBetRankHistory',
    method: 'post',
    data
  })
}
// 获取当前周月卡详情
// Req : open_proto.client.v1.activity.GetWeekMonthCardInfoReq
// Resp: open_proto.client.v1.activity.GetWeekMonthCardInfoResp
export const getWeekMonthCardInfo = (data) => {
  return service({
    url: '/v1/activity/getWeekMonthCardInfo',
    method: 'post',
    data
  })
}
// 团队打码排行榜记录未认证
// Req : open_proto.client.v1.activity.TeamBetRankNoAuthReq
// Resp: open_proto.client.v1.activity.TeamBetRankResp
export const teamBetRankCurrentNoAuth = (data) => {
  return service({
    url: '/v1/activity/teamBetRankNoAuth',
    method: 'post',
    data
  })
}
// 团队打码排行榜记录历史未认证
// Req : open_proto.client.v1.activity.TeamBetRankNoAuthReq
// Resp: open_proto.client.v1.activity.TeamBetRankHistoryResp
export const teamBetRankHistoryNoAuth = (data) => {
  return service({
    url: '/v1/activity/teamBetRankHistoryNoAuth',
    method: 'post',
    data
  })
}
// 周月卡购买记录
// Req : open_proto.client.v1.activity.GetWeekMonthCardRecordReq
// Resp: open_proto.client.v1.activity.GetWeekMonthCardRecordResp
export const getWeekMonthCardRecord = (data) => {
  return service({
    url: '/v1/activity/getWeekMonthCardRecord',
    method: 'post',
    data
  })
}
// 领取周月卡奖励
// Req : open_proto.client.v1.activity.GetWeekMonthCardInfoReq
// Resp: open_proto.client.v1.activity.ReceiveActivityRewardResp
export const receiveWeekMonthCardReward = (data) => {
  return service({
    url: '/v1/activity/receiveWeekMonthCardReward',
    method: 'post',
    data
  })
}
// 团队打码排行榜团队详情
// Req : open_proto.client.v1.activity.TeamBetRankDetailReq
// Resp: open_proto.client.v1.activity.TeamBetRankDetailResp
export const teamBetRankDetail = (data) => {
  return service({
    url: '/v1/activity/teamBetRankDetail',
    method: 'post',
    data
  })
}
// 团队打码排行榜奖励详情
// Req : open_proto.client.v1.activity.TeamBetRankDetailReq
// Resp: open_proto.client.v1.activity.TeamBetRankRankRewardDetailResp
export const teamBetRankRankRewardDetail = (data) => {
  return service({
    url: '/v1/activity/teamBetRankRankRewardDetail',
    method: 'post',
    data
  })
}
// 预览充值奖励活动
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.PreviewRechargeRewardResp
export const previewRechargeReward = (data) => {
  return service({
    url: '/v1/activity/previewRechargeReward',
    method: 'post',
    data
  })
}
// 打开充值收银台
// Req : open_proto.client.v1.activity.OpenRechargeCashReq
// Resp: open_proto.client.v1.activity.OpenRechargeCashResp
export const openRechargeCash = (data) => {
  return service({
    url: '/v1/activity/openRechargeCash',
    method: 'post',
    data
  })
}
// 获取注册送金，充值送金金额
// Req : open_proto.client.v1.activity.GetActivityAmountReq
// Resp: open_proto.client.v1.activity.GetActivityAmountResp
export const getActivityAmount = (data) => {
  return service({
    url: '/v1/activity/getActivityAmount',
    method: 'post',
    data
  })
}
// 聚合注册送金奖励
// Req : open_proto.client.v1.activity.AggRegisterRewardReq
// Resp: open_proto.client.v1.activity.AggRegisterRewardResp
export const aggRegisterReward = (data) => {
  return service({
    url: '/v1/activity/aggRegisterReward',
    method: 'post',
    data
  })
}
// VIP转盘抽奖
// Req : open_proto.client.v1.activity.TurntableDrawReq
// Resp: open_proto.client.v1.activity.TurntableDrawResp
export const vipTurntableDraw = (data) => {
  return service({
    url: '/v1/activity/vipTurntableDraw',
    method: 'post',
    data
  })
}
// VIP转盘奖励列表
// Req : open_proto.client.v1.activity.TurntableRewardListReq
// Resp: open_proto.client.v1.activity.VipTurntableRewardListResp
export const vipTurntableRewardList = (data) => {
  return service({
    url: '/v1/activity/vipTurntableRewardList',
    method: 'post',
    data
  })
}
// 集卡兑奖
// Req : open_proto.client.v1.activity.VipTurntableCollectCardExchangeReq
// Resp: open_proto.client.v1.activity.VipTurntableCollectCardExchangeResp
export const vipTurntableCollectCardExchange = (data) => {
  return service({
    url: '/v1/activity/vipTurntableCollectCardExchange',
    method: 'post',
    data
  })
}
// 获取VIP转盘信息
// Req : open_proto.client.v1.activity.VipTurntableInfoReq
// Resp: open_proto.client.v1.activity.VipTurntableInfoResp
export const getVipTurntableInfo = (data) => {
  return service({
    url: '/v1/activity/getVipTurntableInfo',
    method: 'post',
    data
  })
}
// 获取拉新助力榜单数据
// Req : open_proto.client.v1.activity.GetNewUserHelpInfoRankReq
// Resp: open_proto.client.v1.activity.GetNewUserHelpInfoRankResp
export const getNewUserHelpInfoRank = (data) => {
  return service({
    url: '/v1/activity/getNewUserHelpInfoRank',
    method: 'post',
    data
  })
}
// 奖励列表弹窗
// Req : open_proto.client.v1.activity.GetRewardListReq
// Resp: open_proto.client.v1.activity.GetRewardListResp
export const getRewardList = (data) => {
  return service({
    url: '/v1/activity/getRewardList',
    method: 'post',
    data
  })
}
// 查询充值转盘详情
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.GetRechargeTurntableInfoResp
export const getRechargeTurntableInfo = (data) => {
  return service({
    url: '/v1/activity/getRechargeTurntableInfo',
    method: 'post',
    data
  })
}
// 充值转盘抽奖
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.RechargeTurntableDrawResp
export const drawRechargeTurntable = (data) => {
  return service({
    url: '/v1/activity/drawRechargeTurntable',
    method: 'post',
    data
  })
}
// 充值解锁免费提现信息
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.activity.RechargeUnlockFreeWithdrawInfoResp
export const rechargeUnlockFreeWithdrawInfo = (data) => {
  return service({
    url: '/v1/activity/rechargeUnlockFreeWithdrawInfo',
    method: 'post',
    data
  })
}
